export const buildInfo = {"version": "R1.01.501", "build_at": "2026-06-01 17:17:32 UTC", "git_sha": "main-77be75af"}
